module.exports = __webpack_public_path__ + "static/media/re.9d0be1d4.svg";